import { useEffect, useState, useCallback } from 'react'
import { Item } from '../item'
import { apiClient } from 'core/http'
import { socketClient } from 'core/services'

import c from './assets/sass/list.module.scss'

export const List = ({ onTaskComplete }) => {
    const [tasks, setTasks] = useState([])

    const loadTasks = useCallback(async () => {
        try {
            const res = await apiClient.get('/tasks')
            if (res?.data?.success) {
                setTasks(res.data.tasks)
            }
        } catch (_) {}
    }, [])

    useEffect(() => {
        loadTasks()

        // Увеличили интервал до 5 сек (WebSocket будет обновлять прогресс в реальном времени)
        const interval = setInterval(() => {
            loadTasks()
        }, 5000)

        return () => clearInterval(interval)
    }, [loadTasks])

    useEffect(() => {
        // WebSocket обновление прогресса в реальном времени
        const handleTaskProgress = (data) => {
            console.log('📊 Task progress update received:', data)
            setTasks((prevTasks) =>
                prevTasks.map((task) =>
                    task.id === data.taskId
                        ? { ...task, progress: data.progress }
                        : task
                )
            )
        }

        // Обработка игровых действий для автообновления заданий
        const handleGameAction = (data) => {
            console.log('🎮 Game action received, reloading tasks:', data)
            // При любом игровом действии обновляем список заданий
            setTimeout(() => {
                loadTasks()
            }, 300)
        }

        socketClient.on('task_progress_updated', handleTaskProgress)
        socketClient.on('game_action', handleGameAction)

        return () => {
            socketClient.off('task_progress_updated', handleTaskProgress)
            socketClient.off('game_action', handleGameAction)
        }
    }, [loadTasks])

    return (
        <ul className={c.component}>
            {tasks.length
                ? tasks.map((t) => {
                      // Если есть imageUrl - используем его, иначе определяем по типу
                      let iconType = 'telegram'
                      if (t.imageUrl) {
                          iconType = 'custom'
                      } else if (t.type === 'TELEGRAM_CHANNEL') {
                          iconType = 'telegram'
                      } else if (t.type === 'EXTERNAL_LINK') {
                          if (t.title.toLowerCase().includes('instagram'))
                              iconType = 'instagram'
                          else if (t.title.toLowerCase().includes('vk'))
                              iconType = 'vk'
                          else if (t.title.toLowerCase().includes('youtube'))
                              iconType = 'youtube'
                          else if (t.title.toLowerCase().includes('tiktok'))
                              iconType = 'tiktok'
                          else iconType = 'telegram'
                      }

                      return (
                          <Item
                              key={t.id}
                              id={t.id}
                              type={iconType}
                              imageUrl={t.imageUrl}
                              task={t.title}
                              reward={Number(t.reward)}
                              energy={Number(t.energyReward || 0)}
                              status={
                                  t.status === 'COMPLETED' ? 'done' : undefined
                              }
                              url={t.url}
                              taskType={t.type}
                              requirement={t.requirement}
                              progress={t.progress || 0}
                              onUpdate={loadTasks}
                              onComplete={onTaskComplete}
                          />
                      )
                  })
                : null}
        </ul>
    )
}
